import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PopConfirm from '@omilia/popconfirm';

import InspectHeader from 'components/InspectHeader';
import InspectButton from 'components/InspectButton';
import { intentType } from 'types';

import './style.scss';

class IntentInspectHeader extends Component {
  static propTypes = {
    currentIntent: intentType.isRequired,
    selectedTabIndex: PropTypes.number,
    onAddConstraintSet: PropTypes.func,
    onDelete: PropTypes.func,
  };

  handleDelete = () => {
    this.props.onDelete(this.props.currentIntent.id);
  };

  renderGeneralTabButtons = () => {
    const {
      selectedTabIndex,
      currentIntent: { archived, xpack },
    } = this.props;

    if (selectedTabIndex !== 1 || archived || xpack) {
      return null;
    }

    return (
      <PopConfirm
        confirmLabel="Yes"
        declineLabel="Cancel"
        placement="left"
        title="Are you sure you want to delete this intent?"
        onConfirm={this.handleDelete}
      >
        <InspectButton isHeader data-test="delete-intent-button">
          Delete intent
        </InspectButton>
      </PopConfirm>
    );
  };

  renderContentTabButtons = () => {
    const {
      selectedTabIndex,
      onAddConstraintSet,
      currentIntent: { archived },
    } = this.props;

    if (selectedTabIndex !== 2 || archived) {
      return null;
    }

    return (
      <InspectButton
        isHeader
        data-test="add-constraint-set-button"
        onClick={onAddConstraintSet}
      >
        + Constraint Set
      </InspectButton>
    );
  };

  render() {
    return (
      <InspectHeader styleName="inspect-header">
        {this.renderGeneralTabButtons()}
        {this.renderContentTabButtons()}
      </InspectHeader>
    );
  }
}

export default IntentInspectHeader;
